import { render, staticRenderFns } from "./RequestInfoAction.vue?vue&type=template&id=6c8a1957&"
import script from "./RequestInfoAction.vue?vue&type=script&lang=ts&"
export * from "./RequestInfoAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports